import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LoginRoute, SignUpRoute } from "@/features/authentication/route";
import {
	AboutUsRoute,
	BecomeAPartnerRoute,
	GiveawaysRoute,
	HomeRoute,
	MerchRoute,
	WinnersRoute,
} from "@/features/home/route";
import { ProfileDashboardRoute } from "@/features/profile/route";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../hooks/use-mobile";
import { AuthenticationProvider } from "../providers/authentication";
import { useSiteSettings } from "../providers/site-settings";
import ArrowDownIcon from "../svgs/arrow-down";
import ProfileIcon from "../svgs/profile";

const baseURL = import.meta.env.VITE_SERVER_API_URL;

function LogoutMenuItem() {
	const navigate = useNavigate();

	return (
		<DropdownMenuItem
			onSelect={async () => {
				await AuthenticationProvider.signout();
				navigate(LoginRoute);
			}}
		>
			<span className="web-body-b1">Log out</span>
		</DropdownMenuItem>
	);
}

export default function ProfileButton() {
	const information = AuthenticationProvider.user;
	const initials = information?.fullName
		.split(" ")
		.map((word) => word[0]?.toUpperCase())
		.join("");

	const location = useLocation();
	const locationPath = location.pathname;
	const { settings } = useSiteSettings();
	const storeEnabled = settings.storeEnabled;

	const heroRoutes = [
		HomeRoute,
		AboutUsRoute,
		WinnersRoute,
		BecomeAPartnerRoute,
		GiveawaysRoute,
	];
	const isStoreIndex =
		locationPath === MerchRoute || locationPath === `${MerchRoute}/`;
	const isStoreHero = isStoreIndex && storeEnabled;
	// Match NavigationButton.
	const onWhiteBackground = !(heroRoutes.includes(locationPath) || isStoreHero);

	const isAuthenticated = AuthenticationProvider.isAuthenticated;
	const isMobile = useIsMobile();

	const colorClass =
		"cursor-pointer web-body-b1-medium " +
		(onWhiteBackground ? "text-black" : "text-white");

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				{isAuthenticated ? (
					<div className="flex flex-col">
						<div className="flex flex-row items-center gap-2">
							<Avatar>
								<AvatarImage
									src={`${baseURL}/common/profile-picture/${information?.profilePictureUrl}`}
								/>
								<AvatarFallback>{initials}</AvatarFallback>
							</Avatar>
							{!isMobile && (
								<p className={colorClass}>{information?.fullName}</p>
							)}
							{isMobile && <ArrowDownIcon white={!onWhiteBackground} />}
						</div>

						<div className="md:rounded-1 md:mt-2 md:h-1 md:w-8"></div>
					</div>
				) : (
					<div className="flex flex-col">
						<div className="flex flex-row items-center gap-2">
							<ProfileIcon white={!onWhiteBackground} />
							<ArrowDownIcon white={!onWhiteBackground} />
						</div>
					</div>
				)}
			</DropdownMenuTrigger>

			<DropdownMenuContent>
				<DropdownMenuGroup>
					{isAuthenticated && (
						<DropdownMenuItem>
							<Link to={ProfileDashboardRoute} className="web-body-b1">
								My profile
							</Link>
						</DropdownMenuItem>
					)}
					{isAuthenticated && <LogoutMenuItem />}

					{!isAuthenticated && (
						<DropdownMenuItem>
							<Link to={LoginRoute} className="web-body-b1">
								Log in
							</Link>
						</DropdownMenuItem>
					)}
					{!isAuthenticated && (
						<DropdownMenuItem>
							<Link to={SignUpRoute} className="web-body-b1">
								Sign up
							</Link>
						</DropdownMenuItem>
					)}
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
